import apiClient, { clearSharedGetCache, fetchCachedResource } from "./client";
import { syncEngine } from "../sync/syncEngine";

export const fetchDashboard = async (params = {}) => {
  const response = await apiClient.get("/dashboard", { params });
  return response.data;
};

export const fetchLookups = async () => syncEngine.getLookups() || fetchCachedResource("/lookups", {}, 10 * 60 * 1000);

export const fetchSettings = async () => fetchCachedResource("/settings", {}, 2 * 60 * 1000);

export const fetchReports = async (params = {}) => {
  const response = await apiClient.get("/reports/summary", { params });
  return response.data;
};

export const fetchRevenueReport = async (payload) => {
  const response = await apiClient.post("/reports/revenue/preview", payload);
  return response.data;
};

export const exportRevenueReport = async (payload) => {
  const response = await apiClient.post("/reports/revenue/export", payload);
  return response.data;
};

export const fetchRevenueReportHistory = async (params = {}) => {
  const response = await apiClient.get("/reports/revenue/history", { params });
  return response.data;
};

export const fetchCSAReport = async (params = {}) => {
  const response = await apiClient.get("/reports/csa", { params });
  return response.data;
};

export const fetchTripLinking = async (tripId) => {
  const response = await apiClient.get(`/dispatch-board/${tripId}/linking`);
  return response.data;
};

export const fetchPlanningBoard = async (params = {}) => {
  const response = await apiClient.get("/planning/board", { params });
  return response.data;
};

export const savePlanningAssignment = async (payload) => {
  const response = await apiClient.put("/planning/assignments", payload);
  clearSharedGetCache();
  return response.data;
};

export const savePlanningEquipmentOverride = async (payload) => {
  const response = await apiClient.put("/planning/equipment-overrides", payload);
  clearSharedGetCache();
  return response.data;
};

export const linkTripLoad = async (tripId, payload) => {
  const response = await apiClient.post(`/dispatch-board/${tripId}/link-load`, payload);
  clearSharedGetCache();
  return response.data;
};

export const unlinkTripLoad = async (tripId) => {
  const response = await apiClient.delete(`/dispatch-board/${tripId}/link-load`);
  clearSharedGetCache();
  return response.data;
};

export const deleteDispatchTrip = async (tripId) => {
  const response = await apiClient.delete(`/dispatch-board/trips/${tripId}`);
  clearSharedGetCache();
  return response.data;
};
export const fetchNumberSeries = async () => {
  const response = await apiClient.get("/number-series");
  return response.data;
};

const postNumberSeries = async (path, payload) => {
  const response = await apiClient.post(`/number-series/${path}`, payload);
  clearSharedGetCache();
  return response.data;
};

export const requestNumberSeriesChange = (nextLoadNumber) => postNumberSeries("request", { next_load_number: nextLoadNumber });
export const resendNumberSeriesCode = (requestId) => postNumberSeries("resend", { request_id: requestId });
export const verifyNumberSeriesCode = (requestId, code) => postNumberSeries("verify", { request_id: requestId, code });
export const applyNumberSeriesChange = (requestId, confirmation) => postNumberSeries("apply", { request_id: requestId, confirmation });
export const cancelNumberSeriesChange = (requestId) => postNumberSeries("cancel", { request_id: requestId });
